import { render, staticRenderFns } from "./Slider.vue?vue&type=template&id=1b55dadf&scoped=true&"
import script from "./Slider.vue?vue&type=script&lang=js&"
export * from "./Slider.vue?vue&type=script&lang=js&"
import style0 from "./Slider.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Slider.vue?vue&type=style&index=1&id=1b55dadf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b55dadf",
  null
  
)

export default component.exports